export const STREAM_BOOTSTRAP_REFRESH_MS = 12 * 60 * 1000
export const STREAM_TOKEN_EXPIRY_SKEW_MS = 4 * 60 * 1000

export class ChannelProvisioningPendingError extends Error {
  constructor() {
    super(
      'La discussion est en cours de préparation. Réessayez dans un instant.',
    )
    this.name = 'ChannelProvisioningPendingError'
  }
}

export class StreamBootstrapTransientError extends Error {
  constructor() {
    super('Impossible de renouveler la discussion. Réessayez dans un instant.')
    this.name = 'StreamBootstrapTransientError'
  }
}

export class StreamBootstrapAuthorizationError extends Error {
  constructor(message = 'Accès à la discussion refusé.') {
    super(message)
    this.name = 'StreamBootstrapAuthorizationError'
  }
}

export function toStreamBootstrapError(status: number, error?: string): Error {
  if (status === 503 && error === 'CHANNEL_PROVISIONING_PENDING') {
    return new ChannelProvisioningPendingError()
  }

  if (status === 429 || status >= 500) {
    return new StreamBootstrapTransientError()
  }

  if (status === 401 || status === 403) {
    return new StreamBootstrapAuthorizationError(error)
  }

  return new Error(error || 'Unable to load Stream chat')
}

export function shouldRetryStreamBootstrapError(
  failureCount: number,
  error: unknown,
) {
  return (
    failureCount < 3 &&
    (error instanceof ChannelProvisioningPendingError ||
      error instanceof StreamBootstrapTransientError)
  )
}
